// extracted by mini-css-extract-plugin
export default {"textBox":"Info_textBox__HD+7p"};